import useSessionStorage from "./useSessionStorage";
import SessionStorageKeys from "../constants/SessionStorageConstants";
/**
 * Uses useSession to keep in sync with AuthToken,
 * returns if user has loggedIn or not.
 */
const useLoggedInToken = (): boolean => {
  const [token] = useSessionStorage<string>(SessionStorageKeys.AuthToken, null);

  return !!token;
};

export default useLoggedInToken;
